import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Transition } from "react-transition-group";
import DelayedRender from "../common3/DelayedRender";

const StyledSection = styled.div``;

const Wrapper = styled.div`
  margin-left: ${(p) =>
    p.fluid ? (p.fullScreen ? "50px" : "250px") : "250px"};
  transition: all 300ms ease;
  background-color: #eee;
  padding-top: 79px;
  height: 100vh; // to get all grey background
`;

const FakeLeftMenu = styled.div`
  background-color: ${(p) => p.theme.colors.primary};
  width: 250px;
  height: 100%;
  color: white;
  position: fixed;
  transition: all 500ms ease;
  left: ${(p) => (p.fullScreen ? "-250px" : "-3px")};
  top: -5px;
  margin-top: 20px;
  padding-top: 50px;
`;

const SectionLine = styled.div`
  border-radius: 5px;
  height: 20px;
  background-color: ${(p) => p.theme.colors.secondary};
  margin: 12px 15px;
  width: ${(p) => (p.w ? p.w : "110px")};
  margin-top: 25px;
  margin-bottom: 15px;
  opacity: 0.75;
  transition: transform 150ms ease, opacity 150ms ease;

  transform: scale(${(p) => (p.state === "entered" ? "1" : "0")});
  opacity: ${(p) => (p.state === "entered" ? "0.75" : "0")};
`;

const Line = styled.div`
  border-radius: 5px;
  height: 18px;
  background-color: #eee;
  margin-left: 50px;
  margin-right: 25px;
  margin-top: 10px;
  margin-bottom: 15px;
  opacity: 0.75;
  width: ${(p) => (p.w ? p.w : "150px")};
  transition: transform 150ms ease, opacity 150ms ease;

  transform: scale(${(p) => (p.state === "entered" ? "1" : "0")});
  opacity: ${(p) => (p.state === "entered" ? "0.75" : "0")};
`;

const config = [
  { type: "section", w: "105px" },
  { type: "line", w: "105px" },
  { type: "section", w: "105px" },
  { type: "line", w: "140px" },
  { type: "line", w: "150px" },
  { type: "line", w: "120px" },
  { type: "line", w: "140px" },
  { type: "section", w: "105px" },
  { type: "line", w: "150px" },
  { type: "line", w: "120px" },
  { type: "line", w: "130px" },
  { type: "section", w: "105px" },
  { type: "line", w: "140px" },
  { type: "line", w: "120px" },
  { type: "line", w: "130px" },
  { type: "line", w: "140px" },
  { type: "line", w: "130px" },
  { type: "section", w: "110px" },
  { type: "line", w: "105px" },
  { type: "line", w: "140px" },
  { type: "line", w: "120px" },
  { type: "line", w: "110px" },
];

const FakeLine = (props) => {
  const { width } = props;
  const [_in, setIn] = useState(false);

  useEffect(() => {
    setIn(true);
  }, []);

  return (
    <Transition in={_in} timeout={150}>
      {(state) => <Line w={width} state={state} />}
    </Transition>
  );
};

const FakeSection = (props) => {
  const { width } = props;
  const [_in, setIn] = useState(false);

  useEffect(() => {
    setIn(true);
  }, []);

  return (
    <Transition in={_in} timeout={150}>
      {(state) => <SectionLine w={width} state={state} />}
    </Transition>
  );
};

const FakeMenu = ({ fluid, fullScreen }) => {
  let sectionIndex = 0;
  return (
    <FakeLeftMenu fluid={fluid} fullScreen={fullScreen}>
      {config.map((c, i) => {
        if (c.type === "section") {
          sectionIndex += 2;
          return (
            <DelayedRender waitBeforeShow={sectionIndex * 20}>
              <FakeSection key={i} sectionIndex={sectionIndex} width={c.w} />
            </DelayedRender>
          );
        } else {
          sectionIndex++;
          return (
            <DelayedRender waitBeforeShow={sectionIndex * 20}>
              <FakeLine key={i} sectionIndex={sectionIndex} width={c.w} />
            </DelayedRender>
          );
        }
      })}
    </FakeLeftMenu>
  );
};

const PageTypeAdmin = ({ fluid, fullScreen, children }) => {
  return (
    <React.Fragment>
      <FakeMenu fullScreen={fullScreen} />

      <Wrapper fluid={fluid} fullScreen={fullScreen}>
        <StyledSection className={fluid ? "container-fluid" : "container"}>
          {children}
        </StyledSection>
      </Wrapper>
    </React.Fragment>
  );
};

export default PageTypeAdmin;
